export {
  LoadingSpinner,
  type LoadingSpinnerProps,
} from '@tui-cruises/mein-schiff-web-react-component-library/src/components/core/LoadingSpinner';
